import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Box, useTheme } from "@mui/material";
import TableView from "./util/TableView";
import StringArrayList from "./util/StringArrayList";
import { ADMIN, SENDER, REINDEER, PEOPLE_PARTNER } from "../ListItems";
import { api } from "../api/api";
import { ModuleHeader } from "../../components/composed";
import { Button } from "../../components/primitives";
import { FadeIn } from "../../components/motion";

export default function UsersView(props) {
  const theme = useTheme();
  const [data, setData] = useState([]);

  useEffect(() => {
    props.setShowSearch(true);
  }, []);

  const tableHeader = (
    <TableRow>
      <TableCell>Id</TableCell>
      <TableCell>Name</TableCell>
      <TableCell>Email</TableCell>
      <TableCell>Location</TableCell>
      <TableCell>Role</TableCell>
      <TableCell>Actions</TableCell>
    </TableRow>
  );

  const tableRows = (user, index) => (
    <TableRow key={user.id}>
      <TableCell>{user.id}</TableCell>
      <TableCell>{user.name}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.city}, {user.country}</TableCell>
      <TableCell>
        <StringArrayList
          strings={user.roles}
          stringChange={(str) => str.substring(5, str.length)}
        />
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {[ADMIN, SENDER, REINDEER, PEOPLE_PARTNER].map((role) => {
            return roleButton(role, user, index);
          })}
        </Box>
      </TableCell>
    </TableRow>
  );

  const roleButton = (role, user, index) => {
    const include = user.roles.includes(role);

    return (
      <Button
        key={role}
        onClick={() => {
          callRoleChange(user.id, role, !include, index);
        }}
        variant={include ? "contained" : "outlined"}
        size="small"
      >
        {`${role.substring(5, role.length)}`}
      </Button>
    );
  };

  const callRoleChange = (userId, role, assign, index) => {
    (async () => {
      api.user
        .changeRole(assign, userId, role)
        .then((user) => {
          let newArr = data.slice(0, data.length);
          newArr[index] = user;
          setData(newArr);
        })
        .catch((error) => {
          props.onFetchFailed(error);
        });
    })();
  };

  return (
    <FadeIn>
      <ModuleHeader
        title="Users"
        subtitle="Manage user roles and permissions"
        moduleColor={theme.palette.primary.main}
      />
      <TableView
        fetchUrl={"user/all"}
        tableHeader={tableHeader}
        tableRows={tableRows}
        searchValue={props.searchValue}
        data={data}
        setData={setData}
        {...props}
      />
    </FadeIn>
  );
}
